import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import router from 'next/router';
import Button from '@components/Button/Button';
import styles from '@components/CreativeModalContent/CreativeModalShareProject/CreativeModalShareProject.style';
import { PUBLIC_HOST } from '@config/index';
type PropsType = {
  uuId: string;
};
const CreativeModalShareProject = ({
  uuId
}: PropsType) => {
  const [isUrlCopied, setIsUrlCopied] = useState(false);
  const {
    t
  } = useTranslation('common');
  const {
    locale
  } = router;
  const localePrefix = locale !== router.defaultLocale ? `/${locale}` : '';
  const creativeUrl = `${PUBLIC_HOST}${localePrefix}/creative/${uuId}`;
  const handleTwitterShare = () => {
    const url = `https://twitter.com/intent/tweet?text=${creativeUrl}`;
    window.open(url, '_blank');
  };
  const handleFacebbokShare = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${creativeUrl}`;
    window.open(url, '_blank');
  };
  const handleCopyLink = () => {
    void navigator.clipboard.writeText(creativeUrl);
    setIsUrlCopied(true);
    setTimeout(() => {
      setIsUrlCopied(false);
    }, 5000);
  };
  return <div sx={styles.creativeModal}>
      <p>{t('creative.modal.shareContent')}</p>
      <div sx={styles.buttonsContainer} data-testid="creative-modal-share-project-buttons-container">
        <Button size="small" variant="default" variantColor="brand" onClick={() => handleFacebbokShare()} data-testid="creative-modal-share-project-facebook-button">
          {t('creative.modal.share.facebook')}
        </Button>
        <Button size="small" variant="default" variantColor="brand" onClick={() => handleTwitterShare()} data-testid="creative-modal-share-project-twitter-button">
          {t('creative.modal.share.twitter')}
        </Button>
        <Button size="small" variant="default" variantColor="brand" onClick={() => handleCopyLink()} data-testid="creative-modal-share-project-copy-button">
          {isUrlCopied ? t('creative.modal.share.urlCopied') : t('creative.modal.share.copyUrl')}
        </Button>
      </div>
    </div>;
};
export default CreativeModalShareProject;